import { useState, useEffect, useMemo } from 'react';
import { usePublisherStore } from '.';

function usePublisher() {
    const publisherStore = usePublisherStore();

    const [featuredPublishers, setFeaturedPublishers] = useState([]);
    const [featuredSection, setFeaturedSection] = useState({});
    const [whatshotPublishers, setWhatshotPublishers] = useState([]);
    const [popularNowPublishers, setPopularNowPublishers] = useState([]);
    const [nearMePublishers, setNearMePublishers] = useState([]);
    const [recommendedPublishers, setRecommendedPublishers] = useState([]);
    const [directoryPublishers, setDirectoryPublishers] = useState([]);
    const [directoryFilterIndustries, setDirectoryFilterIndustries] = useState([]);
    const [search, setSearch] = useState({
        whatshotEnabled: false,
        searchText: '',
        industryFilters: [],
    });

    useEffect(() => {
        publisherStore.getFeaturedPublishers();
        publisherStore.getWhatshotPublishers();
        publisherStore.getPopularNowPublishers();
        publisherStore.getNearMePublishers();
        publisherStore.getRecommendedPublishers();
        publisherStore.getDirectoryPublishers();
    }, []);

    useEffect(() => {
        setFeaturedPublishers(publisherStore.featuredPublishers);
        setFeaturedSection(publisherStore.featuredSection);
    }, [publisherStore.observed.featuredPublishers]);

    useEffect(() => {
        setWhatshotPublishers(publisherStore.whatshotPublishers);
    }, [publisherStore.observed.whatshotPublishers]);

    useEffect(() => {
        setPopularNowPublishers(publisherStore.popularNowPublishers);
    }, [publisherStore.observed.popularNowPublishers]);

    useEffect(() => {
        setNearMePublishers(publisherStore.nearMePublishers);
    }, [publisherStore.observed.nearMePublishers]);

    useEffect(() => {
        setRecommendedPublishers(publisherStore.recommendedPublishers);
    }, [publisherStore.observed.recommendedPublishers]);

    useEffect(() => {
        setDirectoryPublishers(publisherStore.directoryPublishers);
        setDirectoryFilterIndustries(publisherStore.directoryFilterIndustries);
    }, [publisherStore.observed.directoryPublishers]);

    useEffect(() => {
        setSearch({ ...publisherStore.search });
    }, [publisherStore.observed.search]);

    const filteredDirectoryPublishers = useMemo(() => {
        const { searchText, whatshotEnabled, industryFilters } = search;
        const q = searchText.trim().toLowerCase();
        return directoryPublishers.filter((p) => {
            if (whatshotEnabled && !p.rank) return false;
            if (industryFilters.length && !industryFilters.some((c) => p.industries?.includes(c))) return false;
            if (q && !p.name.toLowerCase().includes(q) && !p.industries?.join(' ').toLowerCase().includes(q)) return false;
            return true;
        });
    }, [directoryPublishers, search]);

    return {
        featuredPublishers,
        featuredSection,
        whatshotPublishers,
        popularNowPublishers,
        nearMePublishers,
        recommendedPublishers,
        directoryPublishers,
        directoryFilterIndustries,
        filteredDirectoryPublishers,
        search,
    };
}

export default usePublisher;
